import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../client';
import { qk } from './keys';
import type { NewsItem, NewsItemFull, PaginatedResponse } from '../types';
import { withQuery } from '@/utils/url';

export type NewsParams = {
  country_code?: string;
  category?: string;
  severity_min?: number;
  cursor?: string;
  limit?: number;
  [k: string]: string | number | undefined;
};

export function useNews(params: NewsParams = {}) {
  return useQuery({
    queryKey: qk.news(params),
    queryFn: () => apiGet<PaginatedResponse<NewsItem>>(withQuery('/news', params)),
  });
}

export function useNewsItem(id: string | null) {
  return useQuery({
    queryKey: qk.newsItem(id ?? ''),
    queryFn: () => apiGet<NewsItemFull>(`/news/${id ?? ''}`),
    enabled: !!id,
  });
}
